export const MEASUREMENT_LIST_REQUEST = "MEASUREMENT_LIST_REQUEST";
export const MEASUREMENT_LIST_SUCCESS = "MEASUREMENT_LIST_SUCCESS";
export const MEASUREMENT_LIST_FAIL = "MEASUREMENT_LIST_FAIL";

export const MEASUREMENT_DELETE_REQUEST = "MEASUREMENT_DELETE_REQUEST";
export const MEASUREMENT_DELETE_SUCCESS = "MEASUREMENT_DELETE_SUCCESS";
export const MEASUREMENT_DELETE_FAIL = "MEASUREMENT_DELETE_FAIL";

export const MEASUREMENT_LIST_BY_STATUS_REQUEST = "MEASUREMENT_LIST_BY_STATUS_REQUEST";
export const MEASUREMENT_LIST_BY_STATUS_SUCCESS = "MEASUREMENT_LIST_BY_STATUS_SUCCESS";
export const MEASUREMENT_LIST_BY_STATUS_FAIL = "MEASUREMENT_LIST_BY_STATUS_FAIL";

